// The API sends thru either as a bare time - "11:00 PM*", where the asterisk
// marks a hole-10 start - or with the starting hole appended, " 4:30 PM, Hole 1".
//
// Split at the comma so the two halves can wrap independently: the hole drops
// under the tee time when the column is too narrow for both, instead of the
// whole value being clipped.
export const splitThru = (value) => {
  const text = String(value ?? '').trim()
  const comma = text.indexOf(',')

  if (comma === -1) {
    return { time: text, hole: '' }
  }

  return { time: text.slice(0, comma).trim(), hole: text.slice(comma + 1).trim() }
}

const hasStartingHoleMarker = (value) => String(value ?? '').endsWith('*')

// Whether any Thru cell the table renders carries the hole-10 marker, so the
// note explaining it has something to explain. Mirrors aggregate_row: the
// single-round thru shows only with a visible `thru` column, a past round's
// Thru/To Par pair only while that round is in progress. The blob keeps the
// marker on completed rounds' thru values, but the cells are gone with the
// Thru column, so the note goes with them (RTM-10539).
export const hasVisibleStartingHoleMarker = (scope, columns, rounds) => {
  const showsThruColumn = (columns || []).some((column) => column.id === 'thru')

  return (scope || []).some((agg) =>
    (showsThruColumn && hasStartingHoleMarker(agg?.thru))
    || (agg?.pastRounds ?? []).some((pastRound) =>
      rounds?.[pastRound?.id]?.inProgress && hasStartingHoleMarker(pastRound?.thru)))
}
